import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import { Amplify } from 'aws-amplify';
import { defaultStorage } from 'aws-amplify/utils';
import { cognitoUserPoolsTokenProvider } from '@aws-amplify/auth/cognito';
import awsExports from './aws-exports';

Amplify.configure(awsExports);
cognitoUserPoolsTokenProvider.setKeyValueStorage(defaultStorage);

if (environment.production) {
  enableProdMode();
  if (window) {
    window.console.log = function(){};
    window.console.debug = function(){};
    window.console.dir = function(){};
  }
}

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));
